/**
 *  +----------------------------------------------------------------------
 *  | Copyright notion All rights reserved.
 *  +----------------------------------------------------------------------
 *  | 未经许可不能去掉notion相关版权
 *  +----------------------------------------------------------------------
 *  | Author: 诺行
 *  +----------------------------------------------------------------------
 */
import request from '../request.js'

// 获取空写卡库列表
export function listExtraCard(params) {
    return request({
        url: 'extraWriteCard/list.do',
        method: 'post',
        data: params
    })
}

// 导出空写卡库
export function exportExtraCardSync(params) {
    return request({
        url: 'extraWriteCard/export.do?',
        method: 'post',
        data: params
    })
}

// 根据ID删除空写卡库
export function deleteById(params) {
    return request({
        url: 'extraWriteCard/delete.do?',
        method: 'post',
        data: params
    })
}

// 批量导入空写卡库
export function importExcel(params) {
    return request({
        url: 'extraWriteCard/batchImportSync.do?',
        method: 'post',
        data: params,
        timeout: 20000,
        headers: {'Content-Type': 'multipart/form-data'}
    })
}

// 批量删除空写卡库
export function batchDelete(params) {
    return request({
        url: 'extraWriteCard/batchDelete.do?',
        method: 'post',
        data: params,
        timeout: 20000,
        headers: {'Content-Type': 'multipart/form-data'}
    })
}

// 编辑空写卡库
export function editCard(params) {
    return request({
        url: 'extraWriteCard/update.do',
        method: 'post',
        data: params
    })
}

// 写卡操作
export function writeCard(params) {
    return request({
        url: 'extraWriteCard/processCardInfo.do?',
        method: 'post',
        data: params
    })
} 